// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2336":"c84e2073","3507":"c84e2073","4468":"98ba945f"}[chunkId] + ".chunk.css";
};